import { useTranslation } from "react-i18next";
import ScrollReveal from "./ScrollReveal";

const steps = [
  {
    number: "01",
    titleKey: "steps.configure.title",
    descKey: "steps.configure.desc",
    title: "Configurez vos machines et formulaires",
    description:
      "Depuis l'interface web, l'administrateur définit les types de machines et crée des formulaires adaptés.",
  },
  {
    number: "02",
    titleKey: "steps.qrcode.title",
    descKey: "steps.qrcode.desc",
    title: "Générez et déployez vos QR codes",
    description:
      "Chaque équipement reçoit un QR code unique à imprimer et placer sur la machine.",
  },
  {
    number: "03",
    titleKey: "steps.scan.title",
    descKey: "steps.scan.desc",
    title: "Scan, diagnostic et soumission",
    description:
      "L'utilisateur scanne le QR code depuis l'application mobile et soumet sa requête rapidement.",
  },
  {
    number: "04",
    titleKey: "steps.planning.title",
    descKey: "steps.planning.desc",
    title: "Planification et assignation automatique",
    description:
      "Le système identifie les techniciens disponibles et propose automatiquement un créneau.",
  },
  {
    number: "05",
    titleKey: "steps.report.title",
    descKey: "steps.report.desc",
    title: "Intervention et rapport généré",
    description:
      "Le technicien intervient, complète les données terrain, puis un rapport est généré automatiquement.",
  },
];

const PlatformSection = () => {
  const { t } = useTranslation();

  return (
    <section className="assist-section assist-section-alt">
      <div className="assist-container">
        <ScrollReveal className="assist-section-head">
          <p className="assist-section-eyebrow">{t("steps.badge", "Comment ça marche")}</p>
          <h2 className="assist-section-title">{t("steps.title", "Du scan au rapport en 5 étapes")}</h2>
          <p className="assist-section-text">
            {t(
              "steps.subtitle",
              "Un processus fluide et automatisé, de la configuration initiale jusqu'à la génération du rapport final."
            )}
          </p>
        </ScrollReveal>

        <div className="assist-steps-list">
          {steps.map((step, i) => (
            <ScrollReveal key={step.number} delay={i * 90}>
              <article className="assist-card assist-step-card">
                <div className="assist-step-number">{step.number}</div>
                <div>
                  <h3 className="assist-step-title">{t(step.titleKey, step.title)}</h3>
                  <p className="assist-step-text">{t(step.descKey, step.description)}</p>
                </div>
              </article>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PlatformSection;